import React, { FC, MouseEvent, useCallback } from 'react';
import { IconButtonProps } from '@material-ui/core';
import {
  KeyboardBackspaceRounded,
  CloseRounded,
  FullscreenRounded,
  FullscreenExitRounded,
} from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  isTwilioFullscreen,
  setChatInterface,
  setSelectedChat,
  setFullscreen,
} from 'models/twilio';
import ColoredMaterialIcon from './styled/ColoredMaterialIcon';
import ChatIconButton from './styled/ChatIconButton';

export interface CommonButtonProps {
  iconColor?: string;
}

export type MobileChatButtonProps = Omit<IconButtonProps, 'onClick'>
  & CommonButtonProps;

export const ChatCloseButton: FC<MobileChatButtonProps> = ({ iconColor, ...buttonProps }) => {
  const dispatch = useDispatch();

  const onClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
    dispatch(setChatInterface(false));
    e.stopPropagation();
  }, [dispatch]);

  return (
    <ChatIconButton {...buttonProps} onClick={onClick}>
      <ColoredMaterialIcon Icon={CloseRounded} color={iconColor} />
    </ChatIconButton>
  );
};

export const ChatBackButton: FC<MobileChatButtonProps> = ({ iconColor, ...buttonProps }) => {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(setSelectedChat(null));
  }, [dispatch]);

  return (
    <ChatIconButton {...buttonProps} onClick={onClick}>
      <ColoredMaterialIcon Icon={KeyboardBackspaceRounded} color={iconColor} />
    </ChatIconButton>
  );
};

export const ChatFullscreenButton: FC<MobileChatButtonProps> = ({ iconColor, ...buttonProps }) => {
  const dispatch = useDispatch();
  const isFullscreen = useSelector(isTwilioFullscreen);
  const onClick = useCallback(() => {
    dispatch(setFullscreen(!isFullscreen));
  }, [dispatch, isFullscreen]);
  return (
    <ChatIconButton {...buttonProps} onClick={onClick}>
      <ColoredMaterialIcon Icon={isFullscreen ? FullscreenExitRounded : FullscreenRounded} color={iconColor} />
    </ChatIconButton>
  );
};
